import React from 'react'
import { Form } from 'semantic-ui-react'

export default function DirectorySyncRemoveSetting({ syncOptionValue, onChange }) {
  const options = [
    { value: 'delete_user', text: 'Delete the user in Simplesat' },
    { value: 'downgrade', text: 'Downgrade the user to Collaborator role' },
    { value: 'do_nothing', text: 'Keep user and role unchanged in Simplesat' },
  ]
  return (
    <div className="mt4">
      <h3>User removal or 'do not sync' actions</h3>
      <p>
        Choose what happens when a user is either removed from all groups or moved to a group marked
        as 'Do not sync'.
      </p>
      <Form>
        <Form.Group grouped className="!mb-5">
          {options.map((option) => (
            <Form.Checkbox
              key={option.value}
              radio
              label={option.text}
              name="sync_option"
              value={option.value}
              checked={syncOptionValue === option.value}
              onChange={(_, { value }) => onChange(value)}
            />
          ))}
        </Form.Group>
      </Form>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/DirectorySyncRemoveSetting/index.tsx